import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {normalize} from 'core/utils';
import styles from './styles.css';

export default class TermsAndConditionsText extends Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired,
            category: PropTypes.shape({
                name: PropTypes.string.isRequired,
            }).isRequired,
        })),
    };

    getSections(text) {
        return text.replace(/\r/gm, '').split('## ').filter(Boolean);
    }

    getParagraphs(text) {
        return text.replace(/\n+/gm, '\n').split('\n').filter(Boolean);
    }

    render() {
        return (
            <div className={styles.root}>
                {this.props.data.map(item => (
                    <Fragment key={item.id}>
                        <div className={styles.title}>
                            {item.category.name}
                        </div>
                        <div className={styles.list}>
                            {this.getSections(item.text).map((section, sectionIndex) => (
                                <div key={section} className={styles.section}>
                                    {this.getParagraphs(section).map((paragraph, paragraphIndex) => {
                                        let id;
                                        const isSubtitle = paragraphIndex === 0;
                                        if (isSubtitle) {
                                            id = normalize(paragraph.replace(/\s/g, '-'));
                                            paragraph = `${sectionIndex + 1}. ${paragraph}`;
                                        }
                                        const className = classNames({[styles.subtitle]: isSubtitle});
                                        return <p id={id} key={paragraph} className={className}>{paragraph}</p>;
                                    })}
                                </div>
                            ))}
                        </div>
                    </Fragment>
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/terms-and-conditions-text/index.js